import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./screens/Home/HomeScreen";
import About from "./screens/About/AboutUs";
import Doctors from "./screens/About/OurTeam";
import Appointment from "./screens/Contact/Appoinment";
import Treatments from "./screens/Treatments/Treatments";
import Reviews from "./screens/Reviews/Reviews";
import Terms from "./screens/TermsandConditions/Terms";
import PrivacyPolicy from "./screens/PrivacyPolicy/Policy";
import Contact from "./screens/Contact/Contact";
import Articles from "./screens/Reviews/Articles";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
}

function AppLayout() {
  return (
    <div className="min-h-screen bg-brand-beige flex flex-col">
      <Navbar />
      <ScrollToTop />
      <main className="flex-1 pt-20">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/treatments" element={<Treatments />} />
          <Route path="/doctors" element={<Doctors />} />
          <Route path="/news" element={<Reviews />} />
          <Route path="/articles" element={<Articles />} />
          {/* <Route path="/gallery" element={<Gallery />} /> */}
          <Route path="/appointment" element={<Appointment />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Home />} />
             <Route path="/terms" element={<Terms />} />
          <Route path="/privacy_policy" element={<PrivacyPolicy />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppLayout />
    </BrowserRouter>
  );
}
